function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  version: "1.0",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0 120.5v163h106v-163H0zM28.5 255V149h49v13.9H49.3v14.2h28.2V255h-49zm255-64V0H28.3v105.9h28.6V28.5h198v134H120.3V191h21.3v21.2h-21.3v28.3h85.1v-28.3H170V191h113.5z"
})));